var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { SUP_URL } from '../../constants/common';
import BadgeNotifications from '../BadgeNotifications';
import { Wrapper } from './styled';
var SupportLink = function (props) { return (React.createElement(Wrapper, { href: SUP_URL, target: '_blank' },
    "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
    React.createElement(BadgeNotifications, __assign({}, props)))); };
export default SupportLink;
//# sourceMappingURL=SupportLink.js.map